<template>
    <div>
        <div class="flex flex-column">
            <label v-if="fieldLabel" class="mb-2" :class="{ 'font-bold': bold }" :for="fieldLabel">{{ fieldLabel }}:</label>
            <Dropdown
                :id="fieldLabel"
                v-model="selectedOption"
                :options="fieldOptions"
                :optionLabel="props.optionLabel"
                :optionValue="props.optionValue"
                :placeholder="placeholderLabel(fieldLabel)"
                class="mb-1"
                :class="{ 'p-invalid': props.errorMessage }"
                :filter="props.filter"
                :showClear="props.showClear"
                @change="emit('update:modelValue', selectedOption)"
                :disabled="props.disabled"
            />
            <small class="p-invalid" v-if="props.errorMessage"> {{ props.errorMessage }}</small>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, computed, watch } from 'vue';
import { placeholderLabel } from '../../utilities/index.js';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: {
        type: [Number, String],
    },
    label: {
        type: String,
    },
    options: {
        type: Array,
    },
    optionLabel: {
        type: String,
        default: 'name',
    },
    optionValue: {
        type: String,
        default: 'id',
    },
    errorMessage: {
        type: String,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    showClear: {
        type: Boolean,
        default: true,
    },
    bold: {
        type: Boolean,
        default: false,
    },
    filter: {
        type: Boolean,
        default: false,
    },
});

// computed properties
const fieldValue = computed(() => {
    return props.modelValue;
});

// state
const selectedOption = ref(null);

// computed properties
const fieldLabel = computed(() => {
    return props.label ?? null;
});

const fieldOptions = computed(() => {
    return props.options;
});

// watches for modelValue changes
watch(fieldValue, () => {
    updateSelectedOption();
});

onMounted(() => {
    updateSelectedOption();
});

const updateSelectedOption = () => {
    selectedOption.value = fieldValue.value;
};
</script>
